/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17.05 6.91a3.957 3.957 0 0 1-1.8-3.31h-2.838l-.005 11.377a2.387 2.387 0 0 1-2.382 2.297 2.388 2.388 0 0 1-2.386-2.387 2.39 2.39 0 0 1 2.386-2.386c.246 0 .481.04.704.11V9.713a5.206 5.206 0 0 0-.704-.051A5.232 5.232 0 0 0 4.8 14.887c0 1.768.883 3.333 2.23 4.279a5.195 5.195 0 0 0 2.995.947 5.231 5.231 0 0 0 5.226-5.226V9.118a6.75 6.75 0 0 0 3.949 1.27V7.55a3.924 3.924 0 0 1-2.15-.64Z"
})), "0 0 24 24", "Tiktok");